export const tableContent = {
  pendingApprovals: {
    rowData: [
      { name: 'Alice', age: 25, country: 'USA' },
      { name: 'Bob', age: 30, country: 'Canada' },
      { name: 'Charlie', age: 28, country: 'UK' },
    ],
    columnDefs: [
      { headerName: 'Name', field: 'name' },
      { headerName: 'Age', field: 'age' },
      { headerName: 'Country', field: 'country' },
    ]
  },
  rolesContent: {
    rowData: [
      { shipmentId: 'S001', status: 'In Transit', eta: '2025-06-20' },
      { shipmentId: 'S002', status: 'Delivered', eta: '2025-06-15' },
    ],
    columnDefs: [
      { headerName: 'Shipment ID', field: 'shipmentId' },
      { headerName: 'Status', field: 'status' },
      { headerName: 'ETA', field: 'eta' },
    ]
  },
  deleteRoleContent: {
    rowData: [
      { shipmentId: 'S001', status: 'In Transit', eta: '2025-06-20' }
    ],
    columnDefs: [
      { headerName: 'Shipment ID', field: 'shipmentId' },
      { headerName: 'Status', field: 'status' },
      { headerName: 'ETA', field: 'eta' },
    ]
  }
};
